import React, { useState, useEffect } from "react";
import cn from "classnames";

import styles from "./Dropdown.module.sass";
import remove_accents from "remove-accents";
import { useDispatch, useSelector } from "react-redux";
import {
  pickerObjednavky_typERP_BBData,
  pickerObjednavky_typERP_BB,
} from "./redux/PickerObjednavky_typERP_BBSlice";
import axios from "axios";
import { Objednavky_typERP_BBUrl } from "../../../features/urlHelper";
import { loginData } from "../../SignIn/redux/loginSlice";


const Dropdown = ({ className, classDropdownHead, options, small, upBody }) => {
  const pickerObjednavky_typERP_BBdata = useSelector(pickerObjednavky_typERP_BBData);
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  //const logindata = useSelector(loginData)

  return (
    // <ClickAwayListener
    //   onClickAway={() => {
    //     setVisible(false)
    //   }}
    // >
    <div
      className={cn(
        styles.dropdown,
        className,
        { [styles.small]: small },
        {
          [styles.active]: visible,
        }
      )}
    >
      <div
        className={cn(styles.head, classDropdownHead)}
        onClick={() => {
          setVisible(!visible);
        }}
        title={window.innerWidth > 1058 ? "" : pickerObjednavky_typERP_BBdata}
      >
        {window.innerWidth > 1058
          ? pickerObjednavky_typERP_BBdata
          : pickerObjednavky_typERP_BBdata.slice(0, 9)}
      </div>
      <div className={cn(styles.body, { [styles.bodyUp]: upBody })}>
        {options.map((x, index) => {
          return (
            <div
              className={cn(styles.option, {
                [styles.selectioned]: x === pickerObjednavky_typERP_BBdata,
              })}
              onClick={() => {
                setVisible(false);
                dispatch(pickerObjednavky_typERP_BB({ data: x }));
              }}
              key={index}
            >
              {x}
            </div>
          );
        })}
      </div>
    </div>
    // </ClickAwayListener>
  );
};

export default Dropdown;
